
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'volume_off': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M13.5 9A4.5 4.5 0 0 0 11 4.97v2.21l2.45 2.45A4.231 4.231 0 0 0 13.5 9zM16 9a6.843 6.843 0 0 1-.54 2.64l1.51 1.51A8.8 8.8 0 0 0 18 9a9 9 0 0 0-7-8.77v2.06A7.005 7.005 0 0 1 16 9zM1.27 0L0 1.27 4.73 6H0v6h4l5 5v-6.73l4.25 4.25A6.924 6.924 0 0 1 11 15.7v2.06a8.99 8.99 0 0 0 3.69-1.81L16.73 18 18 16.73l-9-9L1.27 0zM9 1L6.91 3.09 9 5.18V1z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
